var _style, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHillFlag01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.7 599.2",
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);fill:#F9F9F9;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#F9F9F9;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#008080;}\n\t.st4{clip-path:url(#SVGID_10_);fill:#07AAA5;}\n\t.st5{clip-path:url(#SVGID_12_);fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_14_);fill:#102A54;}\n\t.st7{clip-path:url(#SVGID_16_);fill:#F9F9F9;}\n\t.st8{clip-path:url(#SVGID_18_);fill:#F9F9F9;}\n\t.st9{clip-path:url(#SVGID_20_);fill:#F9F9F9;}\n\t.st10{clip-path:url(#SVGID_22_);fill:#F9F9F9;}\n\t.st11{clip-path:url(#SVGID_24_);fill:#F9F9F9;}\n\t.st12{clip-path:url(#SVGID_26_);fill:#F9F9F9;}\n\t.st13{clip-path:url(#SVGID_28_);fill:#102A54;}\n\t.st14{clip-path:url(#SVGID_30_);fill:#FFFFFF;}\n\t.st15{opacity:0.61;clip-path:url(#SVGID_32_);fill:#F9F9F9;enable-background:new    ;}\n\t.st16{opacity:0.26;clip-path:url(#SVGID_34_);fill:#3C94F8;enable-background:new    ;}\n\t.st17{opacity:0.18;clip-path:url(#SVGID_36_);fill:#3C94F8;enable-background:new    ;}\n\t.st18{opacity:0.1;clip-path:url(#SVGID_38_);fill:#3C94F8;enable-background:new    ;}\n\t.st19{opacity:0.14;clip-path:url(#SVGID_40_);fill:#3C94F8;enable-background:new    ;}\n\t.st20{clip-path:url(#SVGID_42_);fill:#F9F9F9;}\n\t.st21{clip-path:url(#SVGID_44_);fill:#102A54;}\n\t.st22{clip-path:url(#SVGID_46_);fill:#102A54;}\n\t.st23{clip-path:url(#SVGID_48_);fill:#6CB597;}\n\t.st24{clip-path:url(#SVGID_50_);fill:#102A54;}\n\t.st25{clip-path:url(#SVGID_52_);fill:#102A54;}\n\t.st26{clip-path:url(#SVGID_54_);fill:#6CB597;}\n\t.st27{clip-path:url(#SVGID_56_);fill:#102A54;}\n\t.st28{clip-path:url(#SVGID_58_);fill:#F99747;}\n\t.st29{clip-path:url(#SVGID_60_);fill:#FFC0B1;}\n\t.st30{clip-path:url(#SVGID_62_);fill:#006663;}\n\t.st31{clip-path:url(#SVGID_64_);fill:#008080;}\n\t.st32{clip-path:url(#SVGID_66_);fill:#0C203F;}\n\t.st33{clip-path:url(#SVGID_68_);fill:#102A54;}\n\t.st34{clip-path:url(#SVGID_70_);fill:#FFC0B1;}\n\t.st35{clip-path:url(#SVGID_72_);fill:#102A54;}\n\t.st36{clip-path:url(#SVGID_74_);fill:#FFFFFF;}\n\t.st37{clip-path:url(#SVGID_76_);fill:#102A54;}\n\t.st38{clip-path:url(#SVGID_78_);fill:#102A54;}\n\t.st39{clip-path:url(#SVGID_80_);fill:#FFC0B1;}\n\t.st40{clip-path:url(#SVGID_82_);fill:#102A54;}\n\t.st41{clip-path:url(#SVGID_84_);fill:#F99747;}\n\t.st42{clip-path:url(#SVGID_86_);fill:#102A54;}\n\t.st43{clip-path:url(#SVGID_88_);fill:#F99747;}\n\t.st44{clip-path:url(#SVGID_90_);fill:#102A54;}\n\t.st45{clip-path:url(#SVGID_92_);fill:#102A54;}\n\t.st46{clip-path:url(#SVGID_94_);fill:#FFC0B1;}\n\t.st47{clip-path:url(#SVGID_96_);fill:#FFC0B1;}\n\t.st48{clip-path:url(#SVGID_98_);fill:#102A54;}\n\t.st49{clip-path:url(#SVGID_100_);fill:#7FC0FF;}\n\t.st50{clip-path:url(#SVGID_102_);fill:#7FC0FF;}\n\t.st51{clip-path:url(#SVGID_104_);fill:#102A54;}\n\t.st52{clip-path:url(#SVGID_106_);fill:#D2FFFE;}\n\t.st53{clip-path:url(#SVGID_108_);fill:#008080;}\n\t.st54{clip-path:url(#SVGID_110_);fill:#04AFAA;}\n\t.st55{fill:none;}\n\t.st56{fill:#2F3050;}\n\t.st57{fill:#1A1924;}\n\t.st58{fill:#4C4F81;}\n\t.st59{fill:#222231;}\n\t.st60{fill:#FFFFFF;}\n\t.st61{fill:#00B0C2;}\n\t.st62{fill:#E64645;}\n\t.st63{fill:#009EE2;}\n\t.st64{fill:#93C01F;}\n\t.st65{fill:#273C5C;}\n\t.st66{fill:#3D3F68;}\n\t.st67{fill:#7FC0FF;}\n\t.st68{fill:#102A54;}\n\t.st69{fill:#181936;}\n\t.st70{fill:#006663;}\n\t.st71{fill:#2A2F58;}\n\t.st72{fill:#008080;}\n\t.st73{fill:#06183C;}\n\t.st74{fill:#673438;}\n\t.st75{fill:#21263D;}\n\t.st76{fill:#F99747;}\n\t.st77{fill:#7E9BC1;}\n\t.st78{fill:#6E85B4;}\n\t.st79{fill:#9CB6E0;}\n\t.st80{fill:#A36F68;}\n\t.st81{fill:#8E5C57;}\n\t.st82{display:none;opacity:0.1;fill:#008080;}\n\t.st83{opacity:0.1;fill:#008080;}\n\t.st84{clip-path:url(#XMLID_2_);fill:#E57492;}\n\t.st85{opacity:0.52;}\n\t.st86{opacity:0.3;clip-path:url(#XMLID_3_);fill:#096866;}\n\t.st87{clip-path:url(#XMLID_3_);fill:#096866;}\n\t.st88{opacity:0.3;clip-path:url(#XMLID_4_);fill:#096866;}\n\t.st89{clip-path:url(#XMLID_4_);fill:#096866;}\n\t.st90{clip-path:url(#XMLID_5_);fill:#1C056D;}\n\t.st91{clip-path:url(#XMLID_6_);fill:#8E5C57;}\n\t.st92{clip-path:url(#XMLID_7_);fill:#1C056D;}\n\t.st93{clip-path:url(#XMLID_8_);fill:#8E5C57;}\n\t.st94{clip-path:url(#XMLID_9_);}\n\t.st95{clip-path:url(#XMLID_10_);fill:#DB7D37;}\n\t.st96{clip-path:url(#XMLID_11_);fill:#008080;}\n\t.st97{opacity:0.37;clip-path:url(#XMLID_12_);fill:#D4DFFF;}\n\t.st98{fill:#096866;}\n\t.st99{clip-path:url(#XMLID_13_);fill:#A36F68;}\n\t.st100{fill:#DB7D37;}\n\t.st101{clip-path:url(#XMLID_14_);fill:#DB7D37;}\n\t.st102{clip-path:url(#XMLID_15_);fill:#181936;}\n\t.st103{fill:#D4DFFF;}\n\t.st104{clip-path:url(#XMLID_16_);fill:#096866;}\n\t.st105{fill:#FC476A;}\n\t.st106{clip-path:url(#XMLID_17_);fill:#E57492;}\n\t.st107{fill:#1C056D;}\n\t.st108{fill:#1B3D9E;}\n\t.st109{clip-path:url(#XMLID_18_);fill:#E57492;}\n\t.st110{clip-path:url(#XMLID_19_);fill:#E57492;}\n\t.st111{clip-path:url(#XMLID_20_);fill:#E57492;}\n\t.st112{clip-path:url(#XMLID_20_);fill:#FFFFFF;}\n\t.st113{clip-path:url(#XMLID_21_);fill:#F99747;}\n\t.st114{fill:#FFE0C1;}\n\t.st115{clip-path:url(#XMLID_22_);fill:#008080;}\n\t.st116{clip-path:url(#XMLID_22_);fill:#096866;}\n\t.st117{clip-path:url(#XMLID_23_);fill:#0F0F0F;}\n\t.st118{opacity:0.12;fill:#008080;}\n\t.st119{opacity:0.41;}\n\t.st120{opacity:0.21;}\n\t.st121{fill:#F6BBBA;}\n\t.st122{fill:#232E33;}\n\t.st123{fill:#60C1D4;}\n\t.st124{fill:#FFDC80;}\n\t.st125{fill:#FEDA80;}\n\t.st126{fill:#F08974;}\n\t.st127{fill:#EA8080;}\n\t.st128{fill:#7E5A54;}\n\t.st129{fill:#54322D;}\n\t.st130{fill:#FBD4B9;}\n\t.st131{fill:#A54667;}\n\t.st132{fill:#F7B283;}\n\t.st133{fill:#F6B699;}\n\t.st134{opacity:0.12;clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#008080;}\n\t.st135{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#CAE7E4;}\n\t.st136{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#9FC9D0;}\n\t.st137{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#243A9D;}\n\t.st138{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#1486CF;}\n\t.st139{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#08A4DD;}\n\t.st140{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED7D65;}\n\t.st141{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#EA684D;}\n\t.st142{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#F69B6E;}\n\t.st143{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M311.7,504.2c44.8,4.6,89.9,6.4,134.1,7.1c104.3,1.8,208.8-6.7,311.5-25.4c70.6-12.8,131.7-41.8,143.9-118.7 c15.8-99.8-33-225.9-141.9-244.6c-33.7-5.8-68.7-5.5-101-16.6c-48.2-16.4-85.7-55.5-136.7-64.8c-52.1-9.4-110,1.7-151.8,36.6 c-18.4,15.3-34.1,33.3-48.8,52.1c-11.4,14.6-21.9,32.8-39.2,41c-21.2,10.1-45.9,2.1-69.2-1c-39.9-5.3-86.9,7.6-116.7,35.3 C64.7,234.3,55.4,288,59.6,328.3c5.5,52.8,31.6,102.4,76.8,131.6C187.4,492.9,252.8,498.2,311.7,504.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_111_",
    points: "896.5,-115.6 66.2,-115.6 66.2,714.8 896.5,714.8 896.5,-115.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#008080"
    },
    d: "M199,578.1 c0,0-68.2-55.6-38.4-152.6s83.5-95.3,57.3-177.2C176.4,118.2,297.2,52.9,387.3,43.6c83.3-8.6,169.9-55,232.3,18 c62.4,73,42.9,105.5,127.4,154c84.5,48.6-2.7,138.9,24.2,187.6c27,48.7,68,120.1,5.8,173.5L199,578.1L199,578.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE7E4"
    },
    d: "M753.6,399.3v7.8 c-1.3,0-2.5-0.2-3.7-0.5c-0.3-0.3-0.6-0.7-0.9-1.1c-0.9-1.4-1.7-3.1-2.3-5.1C748.9,399.7,751.2,399.4,753.6,399.3L753.6,399.3z  M754.8,399.3c2.4,0,4.7,0.4,6.9,1c-0.6,2-1.4,3.7-2.3,5.1c-0.3,0.4-0.6,0.8-0.9,1.1c-1.2,0.3-2.4,0.5-3.7,0.5V399.3L754.8,399.3z  M745.6,400.7c0.6,2.1,1.5,3.9,2.4,5.3c-2.2-0.9-4.2-2.2-5.9-3.8C743.2,401.6,744.4,401.1,745.6,400.7L745.6,400.7z M762.7,400.7 c1.2,0.4,2.4,0.9,3.5,1.5c-1.7,1.6-3.7,2.9-5.9,3.8C761.3,404.6,762.1,402.8,762.7,400.7L762.7,400.7z M744.1,390.6 c0,3.2,0.5,6.3,1.2,9c-1.4,0.5-2.8,1.1-4,1.8l0,0c-0.2-0.2-0.4-0.5-0.6-0.7c-0.4-0.5-0.8-1-1.1-1.6c-0.7-1.2-1.3-2.4-1.7-3.7 c-0.3-0.9-0.5-1.9-0.7-2.8c-0.1-0.6-0.1-1.2-0.2-1.9l0,0H744.1L744.1,390.6z M771.3,390.6c-0.1,4.1-1.7,7.9-4.3,10.7 c-1.2-0.7-2.6-1.3-4-1.8c0.7-2.7,1.1-5.7,1.2-9H771.3L771.3,390.6z M763.1,390.6c0,3.1-0.4,6.1-1.1,8.6c-2.2-0.6-4.6-1-7.2-1.1 v-7.6H763.1L763.1,390.6z M745.3,390.6h8.3v7.6c-2.5,0-5,0.4-7.2,1.1C745.7,396.7,745.3,393.7,745.3,390.6L745.3,390.6z  M741.3,378.7c1.2,0.7,2.6,1.3,4,1.8c-0.7,2.7-1.1,5.7-1.2,9H737C737.2,385.3,738.8,381.6,741.3,378.7L741.3,378.7z M761.9,380.8 c0.7,2.6,1.1,5.5,1.1,8.6h-8.3v-7.6C757.3,381.8,759.7,381.4,761.9,380.8L761.9,380.8z M767,378.7c0.2,0.2,0.4,0.5,0.6,0.7 c0.4,0.5,0.8,1,1.1,1.6c0.7,1.2,1.3,2.4,1.7,3.7c0.3,0.9,0.5,1.9,0.7,2.8c0.1,0.6,0.1,1.2,0.2,1.9l0,0h-7.1c0-3.2-0.5-6.3-1.2-9 C764.5,380,765.8,379.4,767,378.7L767,378.7L767,378.7z M746.4,380.8c2.2,0.6,4.6,1,7.2,1.1v7.6h-8.3 C745.3,386.3,745.7,383.4,746.4,380.8L746.4,380.8z M753.6,372.9v7.8c-2.4,0-4.7-0.4-6.9-1c0.6-2,1.4-3.7,2.3-5.1 c0.3-0.4,0.6-0.8,0.9-1.1C751.1,373.1,752.3,372.9,753.6,372.9L753.6,372.9z M754.8,372.9c1.3,0,2.5,0.2,3.7,0.5 c0.3,0.3,0.6,0.7,0.9,1.1c0.9,1.4,1.7,3.1,2.3,5.1c-2.1,0.6-4.4,1-6.9,1V372.9L754.8,372.9z M748,374c-0.9,1.5-1.8,3.3-2.4,5.3 c-1.2-0.4-2.4-0.9-3.5-1.5C743.8,376.2,745.8,374.9,748,374L748,374z M760.3,374c2.2,0.9,4.2,2.2,5.9,3.8c-1.1,0.6-2.2,1.1-3.5,1.5 C762.1,377.3,761.3,375.5,760.3,374L760.3,374z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE7E4"
    },
    points: "679,216.8 671.7,209.4  701.4,203.8 695.7,233.5 687.8,225.6 622,291.4 594,263.4 531.6,325.8 522.8,317 594,245.8 622,273.8 679,216.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    points: "312.5,162.8 325.9,162.8  325.9,201.2 312.5,201.2 312.5,162.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    points: "293.5,168.9 306.8,168.9  306.8,201.2 293.5,201.2 293.5,168.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    points: "274,176.2 287.4,176.2  287.4,201.2 274,201.2 274,176.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    points: "254.9,182.6 268.3,182.6  268.3,201.2 254.9,201.2 254.9,182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE7E4"
    },
    points: "316.8,141.1 313.2,137.5  327.8,134.8 325,149.4 321.1,145.5 306.8,159.8 299.3,152.2 282.6,168.9 273.2,159.5 256.9,175.8 252.6,171.4 273.2,150.8  282.6,160.2 299.3,143.5 306.8,151.1 316.8,141.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#243A9D"
    },
    points: "482.9,79.2 478.2,79.2  478.2,258.2 482.9,258.2 482.9,79.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#243A9D"
    },
    points: "619.8,250.2 754.2,572.5  485.4,572.5 619.8,250.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    points: "659.8,346.2 619.8,250.2  571.7,365.5 597.2,346 616.9,379.8 632.2,339 657.2,362.5 659.8,346.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#243A9D"
    },
    points: "341.3,250.2 206.9,572.5  475.7,572.5 341.3,250.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    points: "301.3,346.2 341.3,250.2  389.4,365.5 363.9,346 344.2,379.8 328.9,339 305.9,361 301.3,346.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1486CF"
    },
    points: "480.5,174 306.3,572.5  654.8,572.5 480.5,174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    points: "480.5,174 306.3,572.5  480.5,572.5 480.5,174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE7E4"
    },
    points: "428.6,292.7 480.5,174  542.9,316.6 509.8,292.4 480.4,331.1 458.5,283.8 434.7,314.3 428.6,292.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    points: "480.4,331.1 480.5,174  542.9,316.6 509.8,292.4 480.4,331.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ED7D65"
    },
    points: "572.4,96 511.2,96  511.2,144.3 572.4,144.3 558.9,120.1 572.4,96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EA684D"
    },
    points: "511.2,144.3 511.2,127.3  541.8,127.3 511.2,144.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F69B6E"
    },
    points: "541.8,79 482.9,79  482.9,127.3 541.8,127.3 541.8,79  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#243A9D"
    },
    d: "M241.5,574.2c0,1.2-1.5,0-2.7,0 c-9.7-10.9-31.3-36.6-49.1-65.8c-10.8-17.7-20.1-36.6-24.5-54.4c-0.1-0.3,0.1-0.6,0.4-0.7c0.3-0.1,0.6,0.1,0.7,0.4 c4.5,17.7,13.9,36.4,24.7,53.9C209.7,537.9,232.6,564.3,241.5,574.2L241.5,574.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M239.5,574.2c0,0,9.7-12.2,4.5-25.7 C238.7,535,232.2,560.4,239.5,574.2L239.5,574.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M225.5,557c0,0,11.6-21.7,4.9-28.6 C223.7,521.4,220.8,542.8,225.5,557L225.5,557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M213,541.1c0,0,11-16.8,6.7-24 C215.3,510,208,523.2,213,541.1L213,541.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M203.5,528.1c0,0,11.6-15.8,5-24 C201.9,495.9,198.2,513.5,203.5,528.1L203.5,528.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M192.5,511.5c0,0,10.3-12.7,5.6-21 C193.4,482.3,190.6,500.2,192.5,511.5L192.5,511.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M184.1,497.4c0,0,13.4-16.6,6.8-24.2 C184.3,465.6,183.6,490.6,184.1,497.4L184.1,497.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M173.9,476.1c0,0,13.1-16.1,8-23.3 C176.8,445.5,173.9,470.4,173.9,476.1L173.9,476.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M166.8,457.7c0,0,7.7-18.2-0.4-24.2 C158.3,427.7,159.3,450.6,166.8,457.7L166.8,457.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M173.9,476.1c0,0-17.1-14.8-21.8-9.3 C147.4,472.3,167.4,480.6,173.9,476.1L173.9,476.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M184.1,497.4c0,0-24.1-14.9-25.4-5.3 C157.4,501.8,177.7,504.6,184.1,497.4L184.1,497.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M192.5,511.5c0,0-23.6-6.9-23.6,2.1 C168.9,522.6,185,518,192.5,511.5L192.5,511.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M203.5,528.1c0,0-17.6-1.8-21.3,4.4 C178.4,538.7,193.4,538.9,203.5,528.1L203.5,528.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M213,541.1c0,0-21.4,0.9-24.3,9.1 C185.8,558.4,209.1,550,213,541.1L213,541.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M225.5,557c0,0-19.8,1.1-24.2,8.8 C196.9,573.5,218.7,572.7,225.5,557L225.5,557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F69B6E"
    },
    d: "M221.5,454.8 c-7.4-10.9-5.9-14.4-5.9-14.4s-7.8,8.4-15.1,32.6l9,4.2l-10.1-0.3c-2,7.8-3.4,16.4-3.4,25.5c0,9.8,1.4,20.1,4.3,29.8l15.6-0.8 l-12.8,8.5c5.6,13.9,14.7,25.8,27.7,32.2c13.4,0.1,40.5,1.9,42,0.2c5.2-6.3,16.6-23.5,9-45.8l-13,1.8l11.9-4.7 c-3.6-8.8-10.1-18.3-21.2-28.3c-3.9-3.6-7.5-6.9-10.8-10l-8.6,2.4l5.9-5c-11.6-11.3-18.8-19.8-23.3-26.1l-2.9,1.5L221.5,454.8 L221.5,454.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M271.1,571.6 c0.2,0.8-2.5,2.4-2.9,0.4c-1-4.4-3.4-13.2-8.7-24.6c-3.6-7.6-8.4-16.3-15-25.7c-8.3-11.9-20.9-29.6-27.5-47 c-4.6-12.3-6.3-24.4-1.3-34.3c-4.6,10-2.6,22,2.2,34c7,17.2,19.9,34.5,28.4,46.1c6.8,9.4,11.9,18.2,15.6,25.9 C267.4,558.1,270,567,271.1,571.6L271.1,571.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M320.4,572.2 c-6.9,1.1-20.8-0.5-35.1,0.1c-15.4-5.1-32.8-13.4-36.1-25.6c-5.2-19.2,31.9,8.3,29.6-5c-2.3-13.2-36.8-31-32.8-42 c4-11,28,12.3,32.4,6.7c4.5-5.6-22.1-32.6-14.6-45.9c7.5-13.3,13.1,9.6,22,27c8.9,17.4,18.6-6.7,29.6-4 c14.9,3.7-13.4,34.6-5.7,46.8c7.1,11.2,25.4-34.5,29.4-4.3C342.4,549.9,330,564.6,320.4,572.2L320.4,572.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M303.9,563.3 c-2.5-0.3-12.5-1.4-22.2-4c-5.4-1.4-10.7-3.3-14.5-5.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.2,0.1,0.3c3.8,2.5,9.2,4.5,14.6,6 c10.4,3,21.1,4.3,22.7,4.5c1,3.1,1.8,5.8,2.5,8c-0.2,0.2,1.6,1.3,1.2,0c-1.1-3.3-2.5-7.9-4.2-13.2c1-0.8,9.5-7.5,16.7-15.9 c3.5-4.1,6.6-8.5,8.4-12.9c0-0.1,0-0.3-0.1-0.3c-0.1-0.1-0.3,0-0.3,0.1c-1.9,4.3-5.1,8.6-8.6,12.6c-6.7,7.5-14.5,13.6-16.5,15.1 c-3.4-10.5-7.7-23.7-12-36.3c-0.2-0.6-0.4-1.2-0.6-1.7c0.1,0,0.2-0.1,0.2-0.2l18-25.9c0.1-0.1,0-0.2-0.1-0.3 c-0.1-0.1-0.3-0.1-0.3,0l-18.2,25c-4.8-14.1-9.5-27.1-12.6-34.5c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.2-0.1,0.3 c3.3,8,8.3,22.4,13.4,37.6c0.5,1.6,1.1,3.3,1.6,4.9c-2.7-1.3-13.4-6.3-21.4-10.9c-3.9-2.3-7.2-4.5-8.6-6.1c-0.1-0.1-0.2-0.1-0.3,0 c-0.1,0.1-0.1,0.2,0,0.3c1.4,1.7,4.7,4,8.7,6.4c9.2,5.6,22,11.7,22,11.7c0.1,0,0.2,0.1,0.2,0.1C296.8,541,300.9,553.7,303.9,563.3 L303.9,563.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE7E4"
    },
    d: "M339.4,561.6 c-11.9-15.2-54.1-122.2-28.7-130c15.2-4.6,8.2,64.4,33.8,126C356.2,585.8,340.7,563.2,339.4,561.6L339.4,561.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M349,571.9c0,0-15-23.3-26.3-68 c-5-19.9-9.3-44-11.3-72.3c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2c1.8,28.3,6,52.5,11,72.4c11.1,44.9,26.1,68.4,26.1,68.4 c0.2,0.3,0.5,0.4,0.8,0.2C349.1,572.5,349.2,572.1,349,571.9L349,571.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F69B6E"
    },
    d: "M756.8,563.8 c14.6-14.2,73.7-120.3,48.2-132c-15.3-7-17.5,66.2-53,127.1C735.7,586.8,755.1,565.4,756.8,563.8L756.8,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M745.3,573.2c0,0,18.9-22.3,37-67.5 c8-20.1,15.9-44.8,21.9-74c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3c-5.8,29.3-13.6,54.1-21.6,74.3c-17.9,45.5-36.8,68-36.8,68 c-0.2,0.3-0.6,0.3-0.9,0.1C745.1,573.9,745,573.5,745.3,573.2L745.3,573.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#08A4DD"
    },
    d: "M760,451.8c9-10.8,7.8-14.7,7.8-14.7 s7.3,9.7,12.5,36.1l-9.9,3.4l10.7,0.7c1.3,8.4,1.9,17.7,0.9,27.4c-1,10.4-3.6,21.1-7.7,31.1l-16.4-2.5l12.7,10.4 c-6.4,12.1-15.3,22.3-26.8,28.4c-13.8,0-25.9,1.5-48.2,1.5c0,0-20.1-23.5-6.9-52.6l13.6,3.3l-12.1-6.3c4.7-8.9,12.7-18.3,25.4-27.6 c4.6-3.3,8.7-6.5,12.5-9.5l8.9,3.5l-5.7-5.9c13.5-10.7,22-18.9,27.4-25.1l2.9,1.9L760,451.8L760,451.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M697.1,573.9c0,0,2.8-11.5,12.8-28.2 c4.6-7.7,10.6-16.4,18.6-25.6c10.1-11.7,25.3-29.1,34.2-46.8c6.2-12.5,9.2-25.1,5.1-36.2c3.8,11,0.4,23.5-6,35.8 c-9.2,17.4-24.7,34.4-35,45.8c-8.2,9.2-14.5,18-19.3,25.8c-8.5,13.8-12.1,24.2-13.1,27.6c0.4,0.9,1.2,1.5,1.2,1.5s0.8,0.3,1.5,0.5 C697,574,697.1,574,697.1,573.9L697.1,573.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M621.3,569.1 c0,0,25.6-37.7,21.9-76.1c-1.5-16.2-8.3-32.5-24.4-46.1c-0.2-0.2-0.3-0.6-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1 c16.5,13.8,23.5,30.4,25.2,46.8c4,38.9-21.7,77.3-21.7,77.3c-0.3,0.5-0.9,0.6-1.4,0.3C621.1,570.2,621,569.5,621.3,569.1 L621.3,569.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M621.8,568.1c0,0-1.5-2.7-4.1-6.5 c-0.9-1.3-1.9-2.7-2.9-4.1c-0.8-1.1-1.6-2.2-2.5-3.4c-0.8-1.1-1.6-2.3-2.5-3.4c-1.8-2.4-3.8-4.7-6.2-6.6c-0.2-0.1-0.2-0.4-0.1-0.5 c0.1-0.2,0.4-0.2,0.5-0.1c2.9,1.4,5.5,3.2,7.9,5.3c1,0.9,1.9,1.8,2.7,2.7c0.6,0.6,1.1,1.3,1.6,2c1.3,1.8,2.3,3.7,3.2,5.5 c2.4,5,3.2,8.9,3.2,8.9c0.1,0.2,0,0.4-0.2,0.5C622.1,568.5,621.9,568.4,621.8,568.1L621.8,568.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M625.7,563.7c0,0-0.1-3.2-2.6-8.3 c-0.7-1.5-1.6-3.2-2.8-5c-0.7-1.1-1.5-2.3-2.4-3.6c-0.8-1.1-1.5-2.3-2.4-3.6c-1.2-1.7-2.4-3.4-3.9-5.3c-1.3-1.6-2.7-3.3-4.3-5.1 c2,1.3,3.9,2.5,5.6,3.9c1.3,1,2.4,2,3.4,3c1.2,1.1,2.2,2.2,3.1,3.3c0.7,0.8,1.3,1.6,1.8,2.5c0.9,1.4,1.6,2.8,2.2,4.1 c0.4,1,0.8,2,1.1,2.9c0.9,2.7,1.2,4.9,1.3,6.8C626.1,562.1,625.7,563.7,625.7,563.7L625.7,563.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M630.5,554.7c0,0-0.9-4.4-4-10.1 c-0.4-0.8-0.9-1.6-1.4-2.5c-0.7-1.2-1.5-2.3-2.3-3.6c-0.5-0.8-1-1.5-1.6-2.3c-0.8-1.1-1.6-2.3-2.5-3.5c-0.9-1.1-1.8-2.2-2.8-3.3 c-1.5-1.5-3-3-4.8-4.5c2.2,1,4.2,2,6,3.2c1.3,0.9,2.5,1.8,3.6,2.8c1.2,1,2.3,2.1,3.2,3.3c0.7,0.8,1.3,1.6,1.8,2.5 c0.9,1.4,1.6,2.7,2.1,4.1c0.4,1,0.8,1.9,1.1,2.9C630.9,549.9,630.5,554.7,630.5,554.7L630.5,554.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M634.5,545.7c0,0-1.2-4.4-4.6-9.8 c-0.5-0.8-1-1.6-1.5-2.4c-0.7-1.1-1.6-2.2-2.4-3.4c-0.5-0.7-1.1-1.5-1.7-2.2c-0.8-1.1-1.7-2.2-2.7-3.2c-0.9-1-1.9-2-3-3 c-1.6-1.4-3.2-2.7-5.2-4c2.3,0.7,4.3,1.5,6.2,2.6c1.4,0.7,2.6,1.6,3.8,2.5c1.3,1,2.4,2,3.4,3c0.7,0.8,1.4,1.5,1.9,2.3 c0.9,1.3,1.7,2.6,2.3,3.9c0.5,0.9,0.9,1.9,1.2,2.8C634.6,540.9,634.5,545.7,634.5,545.7L634.5,545.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M638.9,533.8c0,0-2-3.9-6.1-8.7 c-0.6-0.7-1.2-1.4-1.9-2.1c-0.9-1-1.9-1.9-2.9-3c-0.6-0.6-1.3-1.3-1.9-1.9c-1-0.9-1.9-1.9-3-2.9c-1-0.9-2.1-1.8-3.3-2.6 c-1.7-1.2-3.4-2.4-5.4-3.5c2.3,0.5,4.3,1.1,6.3,2c1.4,0.6,2.7,1.3,4,2c1.3,0.8,2.6,1.6,3.7,2.5c0.8,0.6,1.5,1.3,2.2,2 c1.1,1.1,2,2.3,2.8,3.5c0.6,0.8,1.1,1.7,1.6,2.5C638.1,529.3,638.9,533.8,638.9,533.8L638.9,533.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M641.3,525.6c0,0-1.9-3.9-6-8.4 c-0.6-0.6-1.2-1.3-1.9-2c-0.9-0.9-1.9-1.8-2.9-2.8c-0.6-0.6-1.3-1.2-2-1.8c-1-0.9-2-1.8-3.1-2.6c-1-0.8-2.1-1.6-3.3-2.4 c-1.7-1.1-3.4-2.1-5.5-3.1c2.2,0.3,4.3,0.8,6.2,1.5c1.4,0.5,2.7,1.1,4,1.7c1.3,0.7,2.6,1.5,3.7,2.3c0.8,0.6,1.6,1.2,2.2,1.9 c1.1,1.1,2,2.2,2.9,3.3c0.6,0.8,1.1,1.6,1.6,2.4C640.6,521.2,641.3,525.6,641.3,525.6L641.3,525.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M643.9,510c0,0-2.4-3-6.9-6.2 c-0.6-0.4-1.3-0.9-2-1.3c-0.9-0.6-2-1.2-3-1.9c-0.7-0.4-1.3-0.8-2-1.2c-1-0.6-2-1.2-3.1-1.7c-1.1-0.5-2.2-1-3.3-1.5 c-1.7-0.6-3.4-1.2-5.4-1.7c2-0.2,3.9-0.2,5.8,0c1.4,0.1,2.6,0.4,3.8,0.7c1.3,0.3,2.6,0.7,3.7,1.2c0.8,0.4,1.6,0.8,2.3,1.2 c1.2,0.7,2.2,1.5,3.1,2.4c0.7,0.6,1.3,1.2,1.8,1.8c1.5,1.7,2.6,3.3,3.4,4.7C643.4,508.7,643.9,510,643.9,510L643.9,510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M644.3,497.1c0,0-2.1-1.6-5.9-3.5 c-1.2-0.6-2.6-1.2-4.1-1.8c-1-0.4-2-0.8-3.1-1.2c-1-0.4-2-0.9-3.1-1.3c-1.5-0.6-3.1-1.2-4.8-1.7c-1.6-0.5-3.2-0.9-5-1.3 c1.9-0.3,3.6-0.4,5.3-0.4c1.2,0,2.4,0.1,3.6,0.2c1.2,0.2,2.4,0.4,3.6,0.7c0.8,0.2,1.6,0.5,2.3,0.8c1.2,0.5,2.2,1.1,3.2,1.7 c0.7,0.5,1.4,0.9,2,1.4C642.4,493.9,644.3,497.1,644.3,497.1L644.3,497.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M643.1,486.8c0,0-1.6-0.8-4.4-1.7 c-1-0.3-2.2-0.6-3.5-1c-1.1-0.3-2.2-0.6-3.5-1c-0.5-0.2-1.1-0.4-1.6-0.6c-0.8-0.3-1.6-0.6-2.5-0.9c-2-0.7-4.1-1.4-6.5-1.9 c1.5-0.3,2.9-0.5,4.3-0.6c1-0.1,2-0.1,2.9,0c1,0,2,0.1,2.9,0.3c0.7,0.1,1.3,0.3,1.9,0.5c1,0.3,1.9,0.7,2.7,1.1 c0.6,0.3,1.2,0.6,1.7,1C641.4,484.6,643.1,486.8,643.1,486.8L643.1,486.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M641,478.3c0,0-2.5-0.7-6.8-1.3 c-0.6-0.1-1.2-0.2-1.8-0.3c-0.8-0.1-1.7-0.3-2.6-0.5c-0.6-0.1-1.1-0.3-1.7-0.4c-0.8-0.2-1.7-0.5-2.6-0.8c-0.9-0.3-1.7-0.5-2.6-0.8 c-1.3-0.4-2.6-0.8-4.1-1.1c1.5-0.3,2.8-0.5,4.2-0.6c1-0.1,1.9-0.1,2.9-0.1c1,0,1.9,0,2.9,0.1c0.6,0.1,1.3,0.2,1.9,0.3 c1,0.2,1.9,0.5,2.7,0.9c0.6,0.2,1.2,0.5,1.7,0.8C639,476.5,641,478.3,641,478.3L641,478.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M637.4,469.4c0,0-2.1-0.4-5.3-0.9 c-0.4-0.1-0.9-0.1-1.4-0.2c-0.6-0.1-1.3-0.2-2-0.4c-0.4-0.1-0.9-0.2-1.3-0.4c-0.6-0.2-1.3-0.5-1.9-0.7c-1.7-0.6-3.2-1.3-5-1.7 c1.1-0.3,2.1-0.6,3.2-0.8c0.8-0.1,1.5-0.2,2.2-0.2c0.8,0,1.5,0,2.2,0.1c0.5,0.1,1,0.2,1.4,0.3c0.7,0.2,1.4,0.5,2.1,0.8 c0.5,0.2,0.9,0.4,1.3,0.7C635.9,467.8,637.4,469.4,637.4,469.4L637.4,469.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M632.1,460.4c0,0-1.3-0.2-4,0.2 c-0.3,0-0.6,0.1-1,0.1c-0.5,0-1,0.1-1.5,0.1c-0.3,0-0.7,0-1,0c-0.5,0-1-0.1-1.6-0.2c-1.3-0.2-2.5-0.5-4.1-0.6 c0.8-0.5,1.5-0.9,2.2-1.3c0.6-0.3,1.1-0.5,1.6-0.7c0.6-0.2,1.1-0.4,1.7-0.5c0.4-0.1,0.8-0.1,1.2-0.1c0.6,0,1.2,0.1,1.7,0.2 c0.4,0.1,0.8,0.2,1.1,0.4c0.8,0.3,1.5,0.7,2,1C631.7,459.8,632.1,460.4,632.1,460.4L632.1,460.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M627.1,454.1c0,0-1.1-0.1-3.4,0.2 c-0.3,0-0.5,0.1-0.8,0.1c-0.4,0-0.8,0.1-1.2,0.1c-0.3,0-0.7,0-1-0.1c-0.5-0.1-1-0.2-1.6-0.3c-1-0.2-1.8-0.4-3-0.5 c0.7-0.6,1.2-0.9,1.8-1.4c0.5-0.3,0.9-0.5,1.4-0.7c0.5-0.2,1-0.4,1.4-0.5c0.3-0.1,0.7-0.1,1-0.1c0.4,0,0.7,0.1,1,0.1 c0.6,0.1,1,0.3,1.5,0.5c0.7,0.3,1.2,0.7,1.7,1C626.8,453.6,627.1,454.1,627.1,454.1L627.1,454.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M620.7,447.8c0,0-0.8-0.4-3.3-0.2 c-0.3,0-0.5,0.1-0.8,0.1c-0.4,0-0.8,0.1-1.2,0c-0.3,0-0.5-0.1-0.8-0.1c-0.4-0.1-0.8-0.2-1.3-0.4c-1.1-0.3-2-0.7-3.4-1.1 c0.7-0.4,1.3-0.7,2-1.1c0.5-0.2,0.9-0.4,1.4-0.5c0.5-0.2,1-0.3,1.4-0.3c0.3,0,0.7,0,1,0c0.4,0,0.7,0.1,1,0.2c0.6,0.2,1,0.3,1.4,0.6 c0.7,0.4,1.2,0.8,1.6,1.2C620.6,447.2,620.7,447.8,620.7,447.8L620.7,447.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M622.9,449.8c0,0-0.1-1.3-0.6-3.6 c-0.1-0.3-0.1-0.6-0.2-0.9c-0.1-0.4-0.2-0.8-0.2-1.3c0-0.3,0-0.6,0-0.9c0-0.4,0.1-0.9,0.1-1.3c0.1-1.2,0.3-2.3,0.3-3.7 c0.6,0.6,1,1.1,1.5,1.8c0.3,0.5,0.6,0.9,0.8,1.4c0.3,0.5,0.4,1,0.6,1.5c0.1,0.3,0.1,0.7,0.2,1c0,0.6-0.1,1.1-0.2,1.6 c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.7-0.5,1.3-0.8,1.8C623.3,449.3,622.9,449.8,622.9,449.8L622.9,449.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M628.8,456.1c0,0,0.2-1.8,0.1-4.8 c0-0.4,0-0.8,0-1.2c0-0.6,0-1.2,0-1.8c0-0.4,0.1-0.8,0.2-1.2c0.1-0.6,0.2-1.2,0.4-1.8c0.3-1.5,0.7-3,0.8-4.8c0.5,0.9,1,1.8,1.3,2.7 c0.3,0.7,0.4,1.3,0.6,2c0.2,0.7,0.3,1.4,0.3,2c0,0.5,0,0.9,0,1.4c-0.1,0.7-0.2,1.4-0.4,2c-0.1,0.5-0.3,0.9-0.5,1.3 C630.2,454.7,628.8,456.1,628.8,456.1L628.8,456.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M633.3,462.2c0,0,0.5-1.8,0.9-4.7 c0.1-0.8,0.2-1.7,0.4-2.7c0.1-0.6,0.1-1.2,0.2-1.8c0.1-0.8,0.3-1.5,0.5-2.3c0.2-1.2,0.5-2.3,0.7-3.6c0.2-1.3,0.4-2.6,0.4-4 c0.6,1.2,1,2.3,1.4,3.5c0.2,0.8,0.4,1.6,0.5,2.5c0.1,0.9,0.2,1.7,0.2,2.5c0,0.6-0.1,1.1-0.2,1.7c-0.2,0.9-0.4,1.7-0.7,2.4 c-0.2,0.5-0.4,1-0.7,1.5C635.2,460.5,633.3,462.2,633.3,462.2L633.3,462.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M639.2,473.3c0,0,1.3-1.9,2.6-5.5 c0.4-1.1,0.7-2.3,1.1-3.7c0.2-0.9,0.4-1.8,0.7-2.8c0.2-0.9,0.5-1.8,0.7-2.8c0.3-1.4,0.7-2.8,0.9-4.4c0.2-1.5,0.4-2.9,0.5-4.6 c0.6,1.6,1,3.1,1.2,4.5c0.2,1.1,0.3,2.1,0.4,3.2c0.1,1.1,0,2.2-0.1,3.2c-0.1,0.7-0.2,1.4-0.4,2.1c-0.3,1.1-0.7,2.1-1.1,3 c-0.3,0.7-0.7,1.3-1,1.9c-1,1.6-2.1,2.8-3,3.7C640.2,472.7,639.2,473.3,639.2,473.3L639.2,473.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M642,481.9c0,0,1.6-1.9,3.6-5 c0.7-1,1.4-2.1,2.1-3.4c0.3-0.5,0.6-0.9,0.9-1.4c0.3-0.4,0.6-0.9,0.9-1.3c0.6-0.9,1.2-1.7,1.8-2.7c1.3-2,2.4-4,3.1-6.4 c0.2,1.6,0.2,3,0,4.5c-0.1,1-0.4,2-0.6,3c-0.3,1-0.7,2-1.1,2.9c-0.3,0.6-0.6,1.2-1,1.8c-0.6,0.9-1.2,1.6-1.9,2.4 c-0.5,0.5-1,1-1.5,1.4C644.9,480.6,642,481.9,642,481.9L642,481.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M643.7,490.6c0,0,2.4-2.1,5.6-5.6 c1.1-1.2,2.2-2.5,3.3-3.9c0.4-0.5,0.9-1.1,1.3-1.7c0.4-0.5,0.9-1.1,1.3-1.6c0.9-1.1,1.7-2.2,2.6-3.3c1.8-2.5,3.3-5.1,4.3-8.2 c0,2-0.2,3.9-0.7,5.8c-0.3,1.3-0.8,2.5-1.3,3.7c-0.5,1.2-1.1,2.4-1.8,3.5c-0.5,0.8-1,1.5-1.5,2.1c-0.9,1-1.8,2-2.7,2.8 c-0.7,0.6-1.3,1.1-2,1.6C647.5,489.1,643.7,490.6,643.7,490.6L643.7,490.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M644.1,501.9c0,0,3-1,7-2.7 c1.4-0.6,2.9-1.3,4.5-2.1c0.6-0.3,1.2-0.6,1.8-0.9c0.6-0.3,1.2-0.6,1.8-0.9c1.2-0.6,2.4-1.2,3.5-1.8c2.6-1.5,4.8-3.4,6.1-6 c-0.4,2.5-1.5,4.7-3.2,6.7c-1.1,1.3-2.4,2.4-3.8,3.4c-1,0.7-2.1,1.3-3.3,1.8c-1.2,0.5-2.4,0.9-3.5,1.2c-1.5,0.4-3,0.7-4.4,0.8 C646.9,502.1,644.1,501.9,644.1,501.9L644.1,501.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M643.2,515.8c0,0,2.9,0.2,7-0.1 c1.4-0.1,2.9-0.3,4.5-0.5c0.6-0.1,1.2-0.2,1.8-0.3c0.6-0.1,1.2-0.2,1.8-0.3c1.2-0.2,2.4-0.3,3.6-0.6c2.6-0.6,5.1-1.5,7.4-3.3 c-1,1.5-2.2,2.8-3.5,3.8c-0.9,0.8-1.9,1.4-3,1.9c-1.1,0.6-2.2,1-3.3,1.3c-0.8,0.2-1.5,0.4-2.3,0.5c-1.2,0.1-2.4,0.2-3.5,0.1 c-0.8,0-1.6-0.1-2.3-0.2C646.5,517.4,643.2,515.8,643.2,515.8L643.2,515.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M640.8,527.1c0,0,2.4,0.1,5.9,0.1 c1.1,0,2.2,0,3.4,0c0.7,0,1.5,0,2.3,0c1,0,2,0.1,3,0.2c1.5,0.1,3,0.2,4.5,0.2c1.7,0,3.2-0.1,4.8-0.4c-1.2,0.9-2.5,1.5-4,2.1 c-1,0.4-1.9,0.6-2.9,0.9c-1,0.2-2,0.4-3,0.5c-0.7,0.1-1.4,0.1-2,0c-1-0.1-2-0.2-3-0.4c-0.7-0.1-1.3-0.3-2-0.5 C643.6,528.6,640.8,527.1,640.8,527.1L640.8,527.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M643.9,509.2c0,0,3.4-0.7,8-1.7 c1.6-0.4,3.4-0.8,5.2-1.1c1.2-0.2,2.3-0.4,3.5-0.6c1.8-0.3,3.6-0.5,5.2-0.9c2.1-0.5,3.8-1.1,5.1-2.2c-1.1,1.7-3,3.2-5.4,4.5 c-1.3,0.7-2.8,1.3-4.4,1.8c-1.1,0.3-2.3,0.6-3.4,0.8c-1.2,0.2-2.3,0.2-3.5,0.3c-1.5,0-2.9,0-4.2-0.1 C646.4,509.7,643.9,509.2,643.9,509.2L643.9,509.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M644.3,496.3c0,0,2-1.3,4.8-3.3 c0.9-0.6,1.8-1.3,2.8-2c0.6-0.4,1.2-0.9,1.8-1.3c0.8-0.5,1.7-1,2.5-1.5c1.3-0.8,2.6-1.5,3.8-2.4c1.4-1,2.6-2,3.4-3.3 c-0.3,1.4-0.9,2.8-1.8,4.2c-0.5,0.8-1.2,1.6-1.9,2.4c-0.7,0.7-1.4,1.4-2.2,2.1c-0.5,0.4-1.1,0.8-1.6,1.2c-0.9,0.5-1.8,1-2.7,1.4 c-0.6,0.3-1.2,0.5-1.8,0.7C647.4,495.8,644.3,496.3,644.3,496.3L644.3,496.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M642.1,521.6c0,0,3,0.1,7.4-0.1 c1.5-0.1,3.1-0.1,4.8-0.2c0.6,0,1.3-0.1,2-0.1c0.6,0,1.3,0,2-0.1c1.3,0,2.6,0,3.9-0.1c3-0.2,5.8-0.5,8.3-1.7 c-1.3,1.2-2.8,2.2-4.5,3c-1.1,0.5-2.2,0.9-3.4,1.3c-1.2,0.3-2.3,0.6-3.6,0.8c-0.8,0.1-1.6,0.2-2.4,0.2c-1.2,0-2.4-0.1-3.6-0.2 c-0.8-0.1-1.6-0.2-2.4-0.4C645.6,523.1,642.1,521.6,642.1,521.6L642.1,521.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M639.4,532.8c0,0,3.2,0.8,7.6,1.7 c1.6,0.3,3.2,0.6,5,1c0.7,0.1,1.4,0.2,2.1,0.4c0.7,0.1,1.4,0.3,2,0.4c1.4,0.3,2.7,0.6,4.1,0.8c3.2,0.5,6.3,0.6,8.9-0.5 c-1.9,1.5-4.3,2.5-7,2.9c-1.7,0.3-3.4,0.3-5.2,0.2c-1.3-0.1-2.5-0.3-3.8-0.6c-1.3-0.3-2.5-0.7-3.6-1.1c-1.5-0.6-2.9-1.2-4.1-1.8 C641.7,534.4,639.4,532.8,639.4,532.8L639.4,532.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M636.3,541.2c0,0,3.2,1.2,7.8,2.4 c1.6,0.4,3.3,0.9,5.2,1.4c0.7,0.2,1.4,0.3,2.1,0.5c0.7,0.2,1.4,0.4,2.1,0.6c1.4,0.4,2.8,0.8,4.2,1.1c3.3,0.7,6.5,1.1,9.4,0.4 c-1.7,1-3.6,1.6-5.7,1.9c-1.3,0.2-2.7,0.3-4,0.3c-1.3,0-2.7-0.1-4-0.3c-0.9-0.1-1.8-0.3-2.6-0.6c-1.3-0.4-2.6-0.8-3.8-1.3 c-0.8-0.4-1.6-0.7-2.4-1.1C639.6,543.9,636.3,541.2,636.3,541.2L636.3,541.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M632.5,550.5c0,0,2.7,1.4,6.9,3 c1.4,0.5,2.9,1,4.6,1.5c0.6,0.2,1.3,0.4,1.9,0.6c0.6,0.2,1.3,0.4,1.9,0.6c1.2,0.4,2.5,0.8,3.8,1.1c1.1,0.3,2.2,0.5,3.4,0.7 c1.7,0.3,3.5,0.5,5.3,0.5c-1.8,0.6-3.6,1-5.4,1.2c-1.3,0.2-2.5,0.2-3.7,0.2c-1.3,0-2.5-0.1-3.7-0.4c-0.8-0.1-1.6-0.4-2.4-0.6 c-1.2-0.4-2.4-0.9-3.4-1.4c-0.8-0.4-1.5-0.8-2.2-1.2C635,553.4,632.5,550.5,632.5,550.5L632.5,550.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M628.3,558.9c0,0,2.6,1.3,6.6,2.8 c1.3,0.5,2.8,1,4.4,1.5c0.6,0.2,1.2,0.4,1.8,0.6c0.6,0.2,1.2,0.4,1.8,0.6c1.2,0.4,2.4,0.9,3.6,1.3c1.1,0.3,2.1,0.7,3.2,0.9 c1.7,0.4,3.3,0.7,5.1,0.9c-1.8,0.5-3.5,0.8-5.2,0.9c-1.2,0.1-2.4,0-3.6,0c-1.2-0.1-2.4-0.3-3.5-0.5c-0.8-0.2-1.6-0.4-2.3-0.7 c-1.2-0.4-2.2-0.9-3.2-1.5c-0.7-0.4-1.4-0.8-2-1.2C630.8,561.7,628.3,558.9,628.3,558.9L628.3,558.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M624.3,566.2c0,0,2.1,1.4,5.2,3.2 c1.1,0.6,2.2,1.2,3.5,1.9c0.5,0.2,0.9,0.5,1.4,0.7c0.5,0.3-5,0.5-5.5,0C625.9,569,624.3,566.2,624.3,566.2L624.3,566.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CAE7E4"
    },
    d: "M667.6,572.7c0,0,3.3,1.4,9.6-0.2 c16.3-4,46-13.4,50.4-29.6c5.2-19.2-31.9,8.3-29.6-5c2.3-13.2,36.8-31,32.8-42c-4-11-28,12.3-32.4,6.7 c-4.5-5.6,22.1-32.6,14.6-45.9c-7.5-13.3-13.1,9.6-22,27c-8.9,17.4-18.6-6.7-29.6-4c-14.9,3.7,13.4,34.6,5.7,46.8 c-7.1,11.2-25.4-34.5-29.4-4.3c-3.8,28.3,14,43.6,23.4,49.6C664.3,573.9,667.6,572.7,667.6,572.7L667.6,572.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FC9D0"
    },
    d: "M672.9,559.5 c2.5-0.3,12.5-1.4,22.2-4c5.4-1.4,10.7-3.3,14.5-5.7c0.1-0.1,0.3,0,0.3,0.1c0.1,0.1,0,0.2-0.1,0.3c-3.8,2.5-9.2,4.5-14.6,6 c-10.4,3-21.1,4.3-22.7,4.5c-1.5,4.9-2.8,8.8-3.5,11.3c-0.1,0.3-1.3,0.2-1.2-0.1c1-3.3,2.9-9.2,5.3-16.4c-1-0.8-9.5-7.5-16.7-15.9 c-3.5-4.1-6.6-8.5-8.4-12.9c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.3,0,0.3,0.1c1.9,4.3,5.1,8.6,8.6,12.6c6.7,7.5,14.5,13.6,16.5,15.1 c3.4-10.5,7.7-23.7,12-36.3c0.2-0.6,0.4-1.2,0.6-1.7c-0.1,0-0.2-0.1-0.2-0.2l-18-25.9c-0.1-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.3-0.1,0.3,0l18.2,25c4.8-14.1,9.5-27.1,12.6-34.5c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.1,0.3 c-3.3,8-8.3,22.4-13.4,37.6c-0.5,1.6-1.1,3.3-1.6,4.9c2.7-1.3,13.4-6.3,21.4-10.9c3.9-2.3,7.2-4.5,8.6-6.1c0.1-0.1,0.2-0.1,0.3,0 c0.1,0.1,0.1,0.2,0,0.3c-1.4,1.7-4.7,4-8.7,6.4c-9.2,5.6-22,11.7-22,11.7c-0.1,0-0.2,0.1-0.2,0.1C680,537.3,675.9,550,672.9,559.5 L672.9,559.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#243A9D"
    },
    d: "M793.9,572.9c0-1.4-0.7-2.5-1.5-2.5 c-32.5,0-589.6,0-622.1,0c-0.8,0-1.5,1.1-1.5,2.5c0,0,0,0,0,0c0,1.4,0.7,2.5,1.5,2.5c32.5,0,589.6,0,622.1,0 C793.2,575.4,793.9,574.2,793.9,572.9C793.9,572.9,793.9,572.9,793.9,572.9L793.9,572.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHillFlag01);
export default __webpack_public_path__ + "static/media/hill_flag-01.febefba09a7b58eecffa560b85f4af65.svg";
export { ForwardRef as ReactComponent };